import React from 'react';
import './StarBorder.css';

const StarBorder = ({
  as: Component = 'div',
  className = '',
  color = '#00FFD1',
  speed = '6s',
  children,
  ...props
}) => {
  return (
    <Component
      className={`star-border-container ${className}`}
      style={{
        '--border-color': color,
        '--border-speed': speed
      }}
      {...props}
    >
      <div className="star-border-gradient-bottom"></div>
      <div className="star-border-gradient-top"></div>
      <div className="star-border-inner">{children}</div>
    </Component>
  );
};

export default StarBorder;
